import {StorageService} from 'src/app/services/storage.service';
import {Router} from '@angular/router';
import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Observable, Subscription} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';
import {Menu} from 'src/app/interfaces/global.interface';
import {AuthService} from 'src/app/services/auth.service';
import {SettingsService} from 'src/app/services/settings.service';
import {SYSTEM_NAME} from "../../../constants/constants";
import {UserProfileComponent} from 'src/app/guest/user-profile/user-profile.component';
import {NotificationsComponent} from 'src/app/modules/settings/notifications/notifications.component';
import {ProfileObject} from "../../../../guest/login/login.graphql";
import {environment} from "../../../../../environments/environment";
import {GET_NOTIFICATIONS, NotificationModel} from "../../../../modules/settings/notifications/notifications";
import {Apollo} from "apollo-angular";

@Component({
  selector: 'app-system-layout',
  templateUrl: './system-layout.component.html',
  styleUrls: ['./system-layout.component.scss'],
})
export class SystemLayoutComponent implements OnInit, OnDestroy {
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe([Breakpoints.XSmall, Breakpoints.Small])
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );
  @Input() menu: Menu;
  @Input() hasMenu;
  sideMenu: Menu;
  user: string;
  institutionName: string;
  authMod: string;
  photo: any;
  title = SYSTEM_NAME;

  userType;
  projectName: string;
  projectIcon: string;
  projectUniqueId: string;
  subscriptions = new Subscription();
  notificationList: NotificationModel[]
  totalUnreadNotification = 0
  page: any

  userProfile: ProfileObject


  constructor(
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService,
    private router: Router,
    private storageService: StorageService,
    private apollo: Apollo,
    private settingsService: SettingsService,
  ) {
  }

  ngOnDestroy(): void {
  }

  ngOnInit() {

    this.userProfile = this.storageService.getItem('profile')
    this.photo = environment.FILE_SERVER_URL + this.userProfile.profilePhoto
    this.sideMenu = this.menu;

    this.loadNotifications()

  }


  logout() {
    this.authService.logout();
  }

  loadNotifications() {
    this.apollo
      .query({
        query: GET_NOTIFICATIONS,
        fetchPolicy: 'network-only',
        variables: {
          filtering: {
            pageNumber: 1,
            itemsPerPage: 5,
          }
        },
      })
      .toPromise()
      .then((data) => {
        let result: any = Object.values(data)[0];
        result = result.getNotifications;
        if (result?.response.status) {
          this.notificationList = result?.data
          this.totalUnreadNotification = result?.stats?.totalUnread
          this.page = result?.page
        }
      });

  }

  editProfile(): void{
    // this.router.navigateByUrl('/settings/user-profile');
    this.settingsService.openDialogModal({
      component: UserProfileComponent,
      width: '60%',
      height: '85%',
      data: null
    })
  }
  notifications():void{
    let dialogRef = this.settingsService.openDialogModal({
      component: NotificationsComponent,
      data: {
        notifications: this.notificationList,
        page: this.page
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.totalUnreadNotification -= 1
      }
    })
  }
}

